import React from 'react';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/components/capstone/base';
import { HazardousWarningTitle } from './AccordionSectionTitle.styles';

const AccordionSectionTitle = ({ title }) => {
  return title === 'Hazardous Car Information' ? (
    <HazardousWarningTitle>
      <AttentionTriangleIcon height={16} width={16} />
      <Text size="normal" fontWeight="bold">
        {title}
      </Text>
    </HazardousWarningTitle>
  ) : title === 'Non-Hazardous Car Information' ? (
    <Text size="normal" fontWeight="bold" color="primaryText">
      All Cars
    </Text>
  ) : (
    <Text size="normal" color="secondaryText">
      {title}
    </Text>
  );
};

export default AccordionSectionTitle;
